// export.repo — approval export (single-use). RLS 0056 backstop.
import { supabase } from '@core/supabase';
import { currentUser } from '@core/session';

export interface ExportReq { id: number; requester_nama: string; outlet: string | null; scope: string; status: string; decided_by: string | null; created_at: string }

/** Token approved-unused milik SPV login (bila ada) → boleh export sekali. */
export async function findApprovedToken(): Promise<{ id: number } | null> {
  const u = currentUser(); if (!u) return null;
  const { data } = await supabase().from('export_approvals').select('id')
    .eq('requester_id', u.id).eq('status', 'approved').order('created_at', { ascending: true }).limit(1).maybeSingle();
  return (data as { id: number } | null) ?? null;
}

/** Konsumsi token (approved→used) ATOMIK: hanya berhasil bila masih 'approved'. true = terpakai. */
export async function consumeToken(id: number, usedScope: string): Promise<boolean> {
  const { data, error } = await supabase().from('export_approvals')
    .update({ status: 'used', used_scope: usedScope, used_at: new Date().toISOString() })
    .eq('id', id).eq('status', 'approved').select('id');
  return !error && (data?.length ?? 0) > 0;
}

/** SPV ajukan permintaan export (pending). */
export async function requestExport(scope: string): Promise<void> {
  const u = currentUser(); if (!u) throw new Error('Sesi tidak valid.');
  const { error } = await supabase().from('export_approvals')
    .insert({ requester_id: u.id, requester_nama: u.nama, outlet: u.outlet, scope, status: 'pending' });
  if (error) throw new Error(error.message);
}

export async function listPending(): Promise<ExportReq[]> {
  const { data, error } = await supabase().from('export_approvals')
    .select('id,requester_nama,outlet,scope,status,decided_by,created_at').eq('status', 'pending').order('created_at', { ascending: true });
  if (error) throw new Error(error.message);
  return (data ?? []) as ExportReq[];
}

/** Riwayat keputusan (approved/rejected/used) — jejak untuk O/M. */
export async function listHistory(): Promise<(ExportReq & { used_scope: string | null })[]> {
  const { data, error } = await supabase().from('export_approvals')
    .select('id,requester_nama,outlet,scope,status,decided_by,created_at,used_scope').neq('status', 'pending').order('created_at', { ascending: false }).limit(50);
  if (error) throw new Error(error.message);
  return (data ?? []) as (ExportReq & { used_scope: string | null })[];
}

export async function decideExport(id: number, approve: boolean): Promise<void> {
  const u = currentUser();
  const { error } = await supabase().from('export_approvals')
    .update({ status: approve ? 'approved' : 'rejected', decided_by: u?.nama ?? '', decided_at: new Date().toISOString() })
    .eq('id', id).eq('status', 'pending');
  if (error) throw new Error(error.message);
}
